import { linkWhatsapp } from "@/lib/telefonos";
import { BotonLink, Button } from "./Button";
import { Icono } from "./Icono";

const CLASE = "w-8 px-0 text-exito hover:bg-exito-suave";

export interface BotonWhatsappProps {
  telefono: string | null;
  /** A quién: queda en el nombre accesible ("WhatsApp a Ana Gómez"). */
  nombre: string;
  /** Si está, en vez de abrir el chat llama a esto (Proveedores: abre el mensaje armado para mandarle). */
  onTocar?: () => void;
}

/** Ícono de WhatsApp, discreto, que abre el chat con ese teléfono (`wa.me`, en otra pestaña o la app); va último en las acciones
 * de la fila (Mati, 2026-10-19). No dibuja nada si el teléfono no alcanza para armar el link (`linkWhatsapp`). Proveedores,
 * fiduciantes y compradores. */
export function BotonWhatsapp({ telefono, nombre, onTocar }: BotonWhatsappProps) {
  const link = linkWhatsapp(telefono);
  if (!link) return null;
  if (onTocar) {
    return (
      <Button variante="fantasma" tamanio="sm" aria-label={`WhatsApp a ${nombre}`} title="WhatsApp" className={CLASE} onClick={onTocar}>
        <Icono nombre="whatsapp" className="size-5" />
      </Button>
    );
  }
  return (
    <BotonLink href={link} externo variante="fantasma" tamanio="sm" aria-label={`WhatsApp a ${nombre}`} title="WhatsApp" className={CLASE}>
      <Icono nombre="whatsapp" className="size-5" />
    </BotonLink>
  );
}
